import { initExploreProjects } from '~/explore/projects';

initExploreProjects();
